<template>
  <section class="mb-20">
    <div class="max-w-screen-xl mx-auto px-4 text-center">
      <!-- Lightning Icon -->
      <div class="max-w-max mx-auto relative mb-6">
        <NuxtImg src="/images/circuit.png" alt="Shopping Bag" width="298" height="179" loading="lazy" />
        <div class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 
          inline-flex items-center justify-center w-14 h-14 sm:w-16 sm:h-16 md:w-20 md:h-20 
          rounded-2xl bg-[image:var(--primary-gradient)]">
          <NsLightning />
        </div>
      </div>

      <!-- Heading -->
      <h2 class="text-xl sm:text-2xl md:text-3xl text-[var(--text-secondary)] font-medium -mt-4 mb-4">
        Lightning-Fast Performance
      </h2>
      <p class="text-sm sm:text-base md:text-lg lg:text-xl text-[var(--text-gray)] max-w-3xl mx-auto mb-12">
        Experience unmatched speed with our Nuxt Store, achieving exceptional Lighthouse scores
        for blazing-fast load times, seamless navigation, and superior user satisfaction.
      </p>

      <!-- Performance Scores -->
      <div class="flex justify-center gap-6 sm:gap-8 mb-10 flex-wrap">
        <div v-for="score in performanceScores" :key="score.label" class="flex flex-col items-center">
          <div class="relative mb-2">
            <svg class="w-20 h-20 sm:w-24 sm:h-24 md:w-28 md:h-28 transform -rotate-90" viewBox="0 0 100 100">
              <!-- Background circle -->
              <circle cx="50" cy="50" r="40" stroke="rgba(75, 85, 99, 0.3)" stroke-width="8" fill="none" />
              <!-- Progress circle -->
              <circle cx="50" cy="50" r="40" stroke="#6DF972" stroke-width="8" fill="none"
                :stroke-dasharray="circumference"
                :stroke-dashoffset="circumference - (score.value / 100) * circumference" stroke-linecap="round"
                class="transition-all duration-1000 ease-out" />
            </svg>
            <div class="absolute inset-0 flex items-center justify-center">
              <span class="text-lg sm:text-xl md:text-2xl font-bold text-white">
                {{ score.value }}
              </span>
            </div>
          </div>
        </div>
      </div>

      <!-- Performance Dashboard (optional) -->
      <NsPerformanceDashboard />
    </div>
  </section>
</template>

<script setup lang="ts">

const NsPerformanceDashboard = defineAsyncComponent(() =>
  import('~/components/NsPerformanceDashboard.vue')
)
const NsLightning = defineAsyncComponent(() =>
  import('~/components/atoms/icons/NsLightning.vue')
)

const performanceScores = ref([
  { label: 'Performance', value: 98 },
  { label: 'Accessibility', value: 94 },
  { label: 'Best Practices', value: 100 },
  { label: 'SEO', value: 92 }
])

const circumference = computed(() => 2 * Math.PI * 40)
</script>

